"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var LogoImg_1 = __importDefault(require("atomicComponents/atoms/Logo/LogoImg"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var single_1 = require("utils/selectors/single");
var PREFIX = 'CompanyMeta';
var classes = {
    logo: "".concat(PREFIX, "-logo"),
    placeholder: "".concat(PREFIX, "-placeholder"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.logo)] = {
            width: 40,
            height: 40,
            objectFit: 'contain',
        },
        _b[".".concat(classes.placeholder)] = {
            borderRadius: 12,
            backgroundColor: theme.palette.grey[500],
        },
        _b);
});
var CompanyMeta = function () {
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var formValues = (0, react_final_form_1.useFormState)({ subscription: { values: true } }).values;
    var _a = formValues.company, logoFileArr = _a.logoFileArr, name = _a.name;
    var logoUrlFromForm = (logoFileArr === null || logoFileArr === void 0 ? void 0 : logoFileArr[0]) && URL.createObjectURL(logoFileArr[0]);
    return ((0, jsx_runtime_1.jsxs)(StyledBox, __assign({ display: "flex", alignItems: "center", py: 3 }, { children: [logoUrlFromForm
                ? (0, jsx_runtime_1.jsx)(LogoImg_1.default, { fullWidth: true, src: logoUrlFromForm, alt: company === null || company === void 0 ? void 0 : company.name })
                : (0, jsx_runtime_1.jsx)(Logo_1.default, { fullWidth: true, brand: company }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ component: "span", ml: 1.5 }, { children: name
                    ? (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2 }, { children: name }))
                    : (0, jsx_runtime_1.jsx)(material_1.Box, { width: 176, height: 16, className: classes.placeholder }) }))] })));
};
exports.default = CompanyMeta;
